module.exports = __webpack_public_path__ + "img/me_XS.261ef448.jpg";